import { render, staticRenderFns } from "./ModernMonitor.vue?vue&type=template&id=973a6ff4&scoped=true&"
import script from "./ModernMonitor.vue?vue&type=script&lang=js&"
export * from "./ModernMonitor.vue?vue&type=script&lang=js&"
import style0 from "./ModernMonitor.vue?vue&type=style&index=0&id=973a6ff4&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973a6ff4",
  null
  
)

export default component.exports